import { http } from 'services';

export const RegionApi = () => http.request.get('/reference/regions');

export const SubRegionApi = ({ region_id }: { region_id: number }) =>
  http.request.get(`/reference/sub-regions/${region_id}`);
